//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import More from './More'

export default {
  data () {
    return {
      isAllowedMove: false,
      isUserUp: false,
      basicdata: {
        poswidth: 20,
        posheight: 20,
        start: {},
        end: {},
        offset: {},
        speed: 0
      },
      temporaryData: {
        setIntervalid: null,
        speedCheckInterval: null, // 暂未使用
        timeStamp: null // 暂未使用
      },
    }
  },

  props: {
    slideData: {
      type: Array,
      default: null
    },
    isWider: {
      type: Boolean,
      default: false
    },
    // 整个滑块左右两端的间隔
    paddingWidth: {
      type: Number,
      default: 20
    },
    title: {
      type: String,
      default: '帖子'
    }
  },

  computed: {
    // 动画执行obj
    styleObj () {
      let style = {}

      style['transform'] = 'translate3D(' + this.basicdata.poswidth + 'px,' + '-50%' + ',0)'

      return style
    },
  },

  methods: {
    clickMore ()  {
      this.$emit('click-more')
    },  

    clickItem (itemData) {
      this.$emit('click-item', itemData)
    },

    // 回正函数
    toCorrect (limit) {
      let clock = this.clock().begin(this)

      clock && clock.to(limit)
    },

    inertia (leftLimit, rightLimit) {
      let aim  = this.basicdata.poswidth + this.basicdata.speed * 10
      if (aim > leftLimit) {
        aim = leftLimit
      } else if (aim < rightLimit) {
        aim = rightLimit
      }

      this.clock().begin(this).to(aim)
    },

    clock () {
      return {
        begin (that) {
          let own = this

          return {
            to (aimPoint) {
              // 判断一下用户是否抬起了鼠标， 如果没有，不进行自动运动
              if (that.isUserUp) {
                return
              }
              if (that.temporaryData.setIntervalid) {
                return
              }
              // console.log(aimPoint - that.basicdata.poswidth)
              that.temporaryData.setIntervalid = setInterval(() => {
                if (!that.isUserUp) {

                  let subVal = aimPoint - that.basicdata.poswidth

                  if (Math.abs(subVal) > 0.5) {
                    if (subVal < 0) {
                      that.basicdata.poswidth = that.basicdata.poswidth - (-subVal / 20)
                    } else if (subVal > 0) {
                      that.basicdata.poswidth = that.basicdata.poswidth + (subVal / 20)
                    } else {
                      own.stop(that)
                    }
                  } else {
                    own.stop(that)
                  }

                } else {
                  own.stop(that)
                }

              }, 5)
            }
          }
        },
        stop (that) {
          clearInterval(that.temporaryData.setIntervalid)
          that.temporaryData.setIntervalid = 0
        }
      }
    },

    swipeOver (e) {
      this.isAllowedMove = false
      this.isUserUp = false
    },

    swipeEnd (e, item) {
      this.isAllowedMove = false
      this.isUserUp = false

      // if (e.type === 'touchmove') {
      //   // 移动端如果y轴发生了偏移
      //   if (this.basicdata.end.y - this.basicdata.start.y > 3) {
      //     return 
      //   }
      // }

      // 如果用户点击
      if (Math.abs(this.basicdata.end.x - this.basicdata.start.x) < 3) {
        this.$emit('click-item', item)

        return
      }


      let leftLimit = this.paddingWidth
      let rightLimit = -(this.$refs.slide.clientWidth - this.$refs.slide.parentElement.offsetWidth + this.paddingWidth)

      // 如果超出展示区域，且用户松开鼠标或者离开触摸屏， 调用回正函数
      if (this.basicdata.poswidth > leftLimit) {
        // 左侧的展示区域
        this.toCorrect(leftLimit)
      } else if (this.basicdata.poswidth < rightLimit) {
        // 右侧的展示区域 
        this.toCorrect(rightLimit)
      } else {
        // console.log(this.basicdata.speed)
        this.inertia(leftLimit, rightLimit)
      }
    },

    swipeStart (e) {
      this.isAllowedMove = true
      this.isUserUp = true

      if (e.type === 'touchstart') {
        if (e.touches.length == 1) {
          this.basicdata.start.x = e.targetTouches[0].clientX
          this.basicdata.start.y = e.targetTouches[0].clientY
        } else {
          return 
        }
      } else {
        this.basicdata.start.x = e.clientX
        this.basicdata.start.y = e.clientY
      }

      this.basicdata.end.x = this.basicdata.start.x
      this.basicdata.end.y = this.basicdata.start.y
      
      this.basicdata.offset.x = parseInt(this.$refs['slide'].style['transform'].match(/\-?[\d\.]+px/g)[0])

      // if (this.speedCheckInterval) {
      //   return 
      // }

      // this.speedCheckInterval = setInterval(() => {
      //   // this.temporaryData.timeStamp = new Date()
      //   let subValX = this.basicdata.end.x - this.basicdata.start.x

      // }, 50)
    },

    swipeMove (e) {
      if (this.isAllowedMove) {

        if (e.type === 'touchmove') {
          this.basicdata.speed = (e.targetTouches[0].clientX - this.basicdata.end.x ) / 1 // 1可以修改
          this.basicdata.end.x = e.targetTouches[0].clientX
          this.basicdata.end.y = e.targetTouches[0].clientY
          // this.basicdata.end.y = e.targetTouches[0].clientY
        } else {
          this.basicdata.speed = e.clientX - this.basicdata.end.x  
          this.basicdata.end.x = e.clientX
          this.basicdata.end.y = e.clientY
          // this.basicdata.end.y = e.clientY
        }



        this.basicdata.poswidth = this.basicdata.end.x - this.basicdata.start.x + this.basicdata.offset.x
        // this.basicdata.poswidth = this.temporaryData.originX + 'px'
      }
    },
  },

  created () {
    // console.log(this.slideData)
  },

  components: {
    More
  }
}



// WEBPACK FOOTER //
// ./src/components/Slide.vue